/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { useMemo, useRef } from 'react';
import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import { FormFieldT, FormItemT, FormSectionT } from '../types';
import { isFieldSchema, isSectionSchema } from '../utils';
import { useStoreState } from '../../../../models/hooks';

function getNestedValue(obj: any, path: string): any {
  if (!obj || !path) {
    return undefined;
  }
  const properties = path.split('.');
  let current = obj;
  for (let i = 0; i < properties.length; /* eslint-disable-line no-plusplus */ i++) {
    if (
      current === null ||
      /* eslint-disable-line */ typeof current !== 'object' ||
      !Object.prototype.hasOwnProperty.call(current, properties[i])
    ) {
      return undefined;
    }
    current = current[properties[i]];
  }
  // eslint-disable-next-line
  return current;
}

function findItemByIdRecursive(items: FormItemT[], targetId: string): FormItemT | null {
  if (!items || !Array.isArray(items)) {
    return null;
  }
  /* eslint-disable-next-line */
  for (const item of items) {
    if (!item || isUndefined(item.id)) /* eslint-disable-line no-continue */ continue;
    if (item.id === targetId) {
      return item;
    }
    if (isSectionSchema(item)) {
      const foundInChildren = findItemByIdRecursive((item as FormSectionT).fields, targetId);
      if (foundInChildren) return foundInChildren;
    } else if (
      isFieldSchema(item) &&
      (item as FormFieldT).inputType === 'yesNo' &&
      Array.isArray((item as FormFieldT).followUpQuestionList)
    ) {
      const fieldWithFollowUps = item as FormFieldT;
      if (fieldWithFollowUps.followUpQuestionList) {
        const foundInFollowUp = findItemByIdRecursive(fieldWithFollowUps.followUpQuestionList, targetId);
        if (foundInFollowUp) return foundInFollowUp;
      }
    }
  }
  return null;
}

export function useGetItemProperty<T = any>(itemId: string | null | undefined, propertyPath: string): T | undefined {
  const formSchema = useStoreState((state) => state.formBuilder.formSchema);

  const previousValueStringRef = useRef<string | null>(null);
  const previousValueRef = useRef<T | undefined>(undefined);

  const extractedValue = useMemo(() => {
    if (!itemId || !formSchema || !propertyPath) {
      return undefined;
    }

    const item = findItemByIdRecursive(formSchema, itemId);
    if (!item) {
      return undefined;
    }

    return getNestedValue(item, propertyPath) as T;
  }, [formSchema, itemId, propertyPath]);

  if (isObject(extractedValue) && extractedValue !== null) {
    const currentValueString = JSON.stringify(extractedValue);
    if (previousValueStringRef.current === currentValueString) {
      return previousValueRef.current;
    }
    previousValueStringRef.current = currentValueString;
    previousValueRef.current = extractedValue;
    return extractedValue;
  }
  previousValueStringRef.current = null;
  previousValueRef.current = extractedValue;
  return extractedValue;
}
